import { AuthContextProps } from 'react-oidc-context';

import UserManager from './UserManager';

export const oidcConfig = {
    userManager: UserManager,
};

// Remove the code and state parameters from the url when you are redirected from the authorize page.
export const onSigninCallback = () => {
    window.history.replaceState({}, document.title, window.location.pathname);
};

export function validate(requiredPermissions: string | undefined, auth: AuthContextProps): boolean {
    if (requiredPermissions === undefined) {
        return false;
    }
    const permissions: string[] = auth.user?.profile['permissions'] as string[];
    return permissions.includes(requiredPermissions);
}
